import React, { useState, useEffect } from "react";
import axios from "axios";
import { codigoEvento } from "../Utils/utils";
import { pdf } from "@react-pdf/renderer";
import FechamentoPDF from "../Relatorios/pdfs/fechamentoPDF";
import { data } from "react-router-dom";

const ModalContent = ({ pdv, turno, maxTurno, onClose }) => {
  const [dataFechamento, setDataFechamento] = useState(null);
  const [totalProdutos, setTotalProdutos] = useState(0);
  const [qtdeProdutos, setQtdeProdutos] = useState(0);
  const [totalPDV, setTotalPDV] = useState(0);
  const [totalRet, setTotalRet] = useState(0);
  const [totalRef, setTotalRef] = useState(0);
  const [reportData, setReportData] = useState({});

  const pdfComponents = {
    fechamento: () => <FechamentoPDF data={reportData} />,
  };

  useEffect(() => {
    getFechamento(turno, maxTurno);
  }, []);

  async function handleExportPDF() {
    const blob = await pdf(pdfComponents["fechamento"]()).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  async function getFechamento(turno, maxTurno) {
    axios
      .get(`${process.env.REACT_APP_API_URL}/fechamento`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          turnoInicial: turno,
          turnoFinal: turno,
          codpdv: pdv,
        },
      })
      .then((response) => {
        console.log(response.data);
        response.data = response.data.map((pdv) => {
          let totalProdutos = 0;
          let totalPagamentos = 0;
          pdv?.produtos.map((produto) => {
            totalProdutos += produto.TOTAL;
          });
          pdv?.pagamentos.map((pagamento) => {
            totalPagamentos += pagamento.VALORPGTO;
          });

          pdv.totalProdutos = totalProdutos;
          pdv.totalPagamentos = totalPagamentos;
          totalPagamentos = 0;
          totalProdutos = 0;
          return pdv;
        });

        setReportData(response.data);
        let total = 0;
        let qtde = 0;
        if (response?.data[0]) {
          setDataFechamento(response.data[0]);
          const totalRet = Math.abs(
            response.data[0]?.retiradas?.reduce(
              (acc, item) => acc + (item.VALOR || 0),
              0
            ) || 0
          );
          const totalRef = Math.abs(
            response.data[0]?.reforcos?.reduce(
              (acc, item) => acc + (item.VALOR || 0),
              0
            ) || 0
          );

          setTotalRef(totalRef);
          setTotalRet(totalRet);
          response.data[0].produtos.forEach((produto) => {
            total += produto.TOTAL;
            qtde += produto.QTDE;
          });
          setTotalProdutos(total);
          setQtdeProdutos(qtde);
          setTotalPDV(
            total + response.data[0].TROCOABERTURA + totalRef - totalRet
          );
        } else {
          setReportData(null);
          setDataFechamento(response.data[0]);
          setTotalRef(0);
          setTotalRet(0);
          setTotalProdutos(0);
          setQtdeProdutos(0);
          setTotalPDV(0);
        }
      });
  }

  return (
    <>
      {Array.from(
        { length: maxTurno },
        (_, i) =>
          i > maxTurno - 15 && (
            <button
              key={i}
              className="mt-4 bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
              onClick={() => getFechamento(i + 1, maxTurno)}
            >
              {i + 1}
            </button>
          )
      )}
      <>
        {dataFechamento ? (
          <>
            <div className="font-Consolas overflow-y-auto max-h-[80vh] overflow-x-hidden">
              <h3 className=" font-bold flex justify-center items-center w-full">
                FECHAMENTO
              </h3>
              <h3 className=" font-bold flex justify-center items-center w-full">
                PDV: {dataFechamento?.CODPDV} - TURNO: {dataFechamento?.TURNO}
              </h3>
              <h3 className=" font-bold flex justify-center items-center w-full">
                {localStorage.getItem("nomeEvento")}
              </h3>

              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Abertura............:
                <span className="text-right min-w-[80px]">
                  {dataFechamento?.DATAABERTURATURNO
                    ? new Date(
                        dataFechamento?.DATAABERTURATURNO
                      ).toLocaleString("pt-BR", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })
                    : ""}
                </span>
              </div>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Fechamento..........:
                <span className="text-right min-w-[80px]">
                  {dataFechamento?.DATAFECHATURNO
                    ? new Date(dataFechamento?.DATAFECHATURNO).toLocaleString(
                        "pt-BR",
                        {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        }
                      )
                    : ""}
                </span>
              </div>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Operador............:
                <span className="text-right min-w-[80px]">
                  {dataFechamento?.RESPONSAVEL}
                </span>
              </div>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Turno...............:
                <span className="text-right min-w-[80px]">
                  {dataFechamento?.TURNO}
                </span>
              </div>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                PDV.................:
                <span className="text-right min-w-[80px]">
                  {dataFechamento?.CODPDV}
                </span>
              </div>

              <h3 className=" font-bold flex justify-center items-center w-full">
                PRODUTOS VENDIDOS
              </h3>

              <table className="w-full">
                <thead>
                  <tr className="text-left font-bold bg-gray-200">
                    <th className="p-2">Cod</th>
                    <th className="p-2">Produto</th>
                    <th className="p-2 text-right">Qtde</th>
                    <th className="p-2 text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {dataFechamento?.produtos.map((produto, i) => (
                    <tr className="text-left font-normal" key={i}>
                      <td className="p-2">{produto.CODPROD}</td>
                      <td className="p-2">{produto.DESCRICAO}</td>
                      <td className="p-2 text-right">{produto.QTDE}</td>
                      <td className="p-2 text-right">
                        {produto.TOTAL?.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="text-left font-bold bg-gray-200">
                    <th className="p-2" colSpan={3}>
                      Total
                    </th>

                    <th className="p-2 text-right">
                      {totalProdutos?.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </th>
                  </tr>
                </tfoot>
              </table>

              <h3 className=" font-bold flex justify-center items-center w-full">
                FORMAS DE PAGAMENTO
              </h3>

              <table className="w-full">
                <thead>
                  <tr className="text-left font-bold bg-gray-200">
                    <th className="p-2">Cod</th>
                    <th className="p-2">Forma de Pagamento</th>
                    <th className="p-2 text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {dataFechamento?.pagamentos.map((pagamento, i) => (
                    <tr className="text-left font-normal" key={i}>
                      <td className="p-2">{pagamento.CODFORMAPGTO}</td>
                      <td className="p-2">{pagamento.DESCRICAOPGTO}</td>
                      <td className="p-2 text-right">
                        {pagamento.VALORPGTO?.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <h3 className=" font-bold flex justify-center items-center w-full">
                TOTAIS
              </h3>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Saldo Inicial........:
                <span className="text-right min-w-[80px]">
                  {dataFechamento?.TROCOABERTURA?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </span>
              </div>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Produtos Vendidos....:
                <span className="text-right min-w-[80px]">{qtdeProdutos}</span>
              </div>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Retirada.............:
                <span className="text-right min-w-[80px]">
                  {totalRet?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </span>
              </div>
              <div className="relative overflow-visible group flex gap-1 w-full items-center justify-between">
                Reforço..............:
                <span className="text-right min-w-[80px]">
                  {totalRef?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </span>
              </div>
              <p className="relative overflow-visible group flex gap-1 w-full items-center justify-between font-bold">
                Saldo Total..........:
                <span className="text-right min-w-[80px]">
                  {totalPDV?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </span>
              </p>
            </div>
            <button
              className="mt-4 bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
              onClick={() => handleExportPDF()}
            >
              Salvar
            </button>
          </>
        ) : (
          <div className="flex justify-center items-center h-96">
            <h1 className="text-lg font-semibold text-gray-700">
              Nenhum dado encontrado para o turno selecionado.
            </h1>
          </div>
        )}
      </>
      <button
        onClick={() => onClose()}
        className="mt-4 bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
      >
        Fechar
      </button>
    </>
  );
};

export default ModalContent;
